// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import { CardLabelSelectView } from 'app/scripts/views/label/CardLabelSelectView';
import { Analytics } from '@trello/atlassian-analytics';
import { Label } from 'app/scripts/models/label';
import labelTemplate from 'app/scripts/views/templates/label';
import cardDetailAddButtonTemplate from 'app/scripts/views/templates/card_detail_add_button';

const openLabelsPopOver = function (elem, options) {
  PopOver.toggle({
    elem,
    view: CardLabelSelectView,
    options: _.extend(
      { model: this.model, modelCache: this.modelCache },
      options,
    ),
  });
};

const editLabelsMainSingleLabel = function (e) {
  stopPropagationAndPreventDefault(e);
  this.openLabelsPopOver(this.$(e.target).closest('.card-label'));
  Analytics.sendClickedButtonEvent({
    buttonName: 'labelsButton',
    source: 'cardDetailScreen',
    containers: this.model.getAnalyticsContainers(),
    attributes: {
      type: 'label',
      cardIsTemplate: this.model.get('isTemplate'),
      cardIsClosed: this.model.get('closed'),
    },
  });
};

const editLabelsMain = function (e) {
  stopPropagationAndPreventDefault(e);
  this.openLabelsPopOver(this.$('.js-details-edit-labels'));
  Analytics.sendClickedButtonEvent({
    buttonName: 'labelsButton',
    source: 'cardDetailScreen',
    containers: this.model.getAnalyticsContainers(),
    attributes: {
      type: 'badge',
      cardIsTemplate: this.model.get('isTemplate'),
      cardIsClosed: this.model.get('closed'),
    },
  });
};

const editLabelsSidebar = function (e) {
  stopPropagationAndPreventDefault(e);
  Analytics.sendClickedButtonEvent({
    buttonName: 'labelsButton',
    source: 'cardDetailScreen',
    containers: this.model.getAnalyticsContainers(),
    attributes: {
      type: 'sidebar',
      cardIsTemplate: this.model.get('isTemplate'),
      cardIsClosed: this.model.get('closed'),
    },
  });

  return this._openEditLabelsSidebar();
};

const renderLabels = function () {
  const activeLabels = this.model.getLabels().sort(Label.compare);

  const $labels = this.$('.js-card-detail-labels-list').empty();

  const labelsHtml = (() => {
    const result = [];
    for (const label of Array.from(activeLabels)) {
      const data = this.model.dataForLabel(label);
      data.extraClasses = ['mod-card-detail'];
      if (this.model.editable()) {
        data.extraClasses.push('mod-clickable');
      }
      result.push(labelTemplate(data));
    }
    return result;
  })();

  $labels.append(labelsHtml);

  if (this.model.editable()) {
    $labels
      .append(cardDetailAddButtonTemplate({ klass: 'js-details-edit-labels' }))
      .addClass('js-edit-label');
  }

  this.$('.js-card-detail-labels').toggleClass(
    'hide',
    activeLabels.length === 0,
  );

  return this;
};

const _openEditLabelsSidebar = function (options) {
  return this.openLabelsPopOver(this.$('.js-edit-labels'), options);
};

export { openLabelsPopOver };
export { editLabelsMainSingleLabel };
export { editLabelsMain };
export { editLabelsSidebar };
export { renderLabels };
export { _openEditLabelsSidebar };
